import { render, staticRenderFns } from "./Desapensar.vue?vue&type=template&id=3da02c68&scoped=true"
import script from "./Desapensar.vue?vue&type=script&lang=js"
export * from "./Desapensar.vue?vue&type=script&lang=js"
import style0 from "./Desapensar.vue?vue&type=style&index=0&id=3da02c68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da02c68",
  null
  
)

export default component.exports